export const getRateSessionURL = (uuid) => {
    return window.location.origin + '/calificar-session/' + uuid;
};
